<template>
  <div>
    <vx-card>
      <heading size="h2" style-size="h4" class="mb-5">
        Your Virtual Tour and Job Experience Induction
      </heading>
      <p class="my-5">
        Please watch the video below to get a feel for the hospital environment from the perspective
        of a nurse.<br />
        This technologically advanced simulation facility prepares medicine and nursing students for
        clinical practice.
      </p>
      <p class="my-5">
        <strong
          >You must scroll down and download the Induction Sheet and read it carefully. This is
          compulsory!</strong
        >
      </p>
      <div class="vx-row mt-10 mb-5">
        <div class="vx-col xl:w-2/3 w-full mx-auto">
          <div>
            <button
              id="video-btn-nursing"
              class="no-style"
              @click="showYoutubePopup(video.url, `video-btn-nursing`)"
            >
              <img
                :src="video.image"
                :alt="video.alt"
                class="img-responsive mx-auto cursor-pointer"
              />
            </button>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <vs-list>
        <vs-list-item
          title="Induction Sheet"
          subtitle="An overview of what is expected of you and the rules you must follow."
        >
          <a
            class="btn btn-primary btn-size-medium"
            aria-label="Download induction sheet for Nursing"
            :href="'content/nurse/induction_sheet_nursing.pdf' | blob_url"
            target="_blank"
          >
            Download
          </a>
        </vs-list-item>
      </vs-list>
    </vx-card>
  </div>
</template>

<script>
import store from '@/store/store';

export default {
  computed: {
    video() {
      return {
        url: 'https://www.youtube.com/embed/EM1iP3iHhKE?autoplay=1',
        image: require('@/assets/images/experiences/' +
          this.experience.vje.folder_name.toLowerCase() +
          '/virtual_tour.jpg'),
        alt: 'Nursing Virtual Tour',
      };
    },
    activeExperienceID() {
      return store.getters['authStudent/activeExperienceID'];
    },
    experience() {
      const loginType = localStorage.getItem('login_type');
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.activeExperienceID);
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
  },
  methods: {
    showYoutubePopup(url, elemId) {
      store.dispatch('popup/showIframePopup', url);
      store.commit('popup/setFocusElemOnPopupClose', elemId);
    },
  },
  beforeMount() {
    store.commit('authStudent/setActiveExperienceID', this.$route.params.id);
  },
};
</script>
